import { MMDirectQuote } from '../../../../../../../coverpath-common/classes/quote/mm-direct/MMDirectQuote';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseQuickQuoteComponent } from '../../../../../../../coverpath-common/angular/components/quote/quick-quote/base-quick-quote.component';
import { QuoteService } from '../../../../../../../coverpath-common/angular/services/quote/quote.service';
import { ValidationService } from '../../../../../../../coverpath-common/angular/services/validation/validation.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ApplicationService } from '../../../../../../../coverpath-common/angular/services/application/application.service';
import { QuickQuoteService } from './../../../../services/quote/quick-quote.service';
import { RateClasses } from '../../../../../../../common/js/static/RateClasses';
import { CoverpathUtils } from '../../../../../../../coverpath-common/js/static/CoverpathUtils';

@Component({
    selector: 'quick-quote',
    moduleId: module.id,
    templateUrl: './quick-quote.component.html'
})
export class QuickQuoteComponent extends BaseQuickQuoteComponent {
    constructor(private quoteServiceInstance: QuoteService,
                private quickQuoteServiceInstance: QuickQuoteService,
                private validationServiceInstance: ValidationService,
                private applicationServiceInstance: ApplicationService,
                private amorphicServiceInstance: AmorphicService,
                private routerInstance: Router) {
                    super(quoteServiceInstance, quickQuoteServiceInstance, validationServiceInstance, applicationServiceInstance,
                        amorphicServiceInstance, routerInstance);
    }

    calculateHealthClass(): void {
        const quote = this.quickQuoteServiceInstance.getCurrentQuote() as MMDirectQuote;
        quote.healthClass = CoverpathUtils.getRateClassStringCode(quote.healthClassNumber, quote.smoker);
        this.setQuoteProperties(quote);
    }

    initializeProperties(): void {
        const quote = this.quickQuoteServiceInstance.getCurrentQuote() as MMDirectQuote;
        quote.gender = quote.gender || '1'; //Male
        quote.dateOfBirth = quote.dateOfBirth || new Date('January, 1 1983');
        quote.healthClassNumber = quote.healthClassNumber || 0;
        quote.smoker = quote.smoker || false;
        quote.contractState = quote.contractState || 'MA';
        quote.term = quote.term || 20;
        quote.faceAmount = quote.faceAmount || 100000;
        quote.healthClass = quote.healthClass || RateClasses.ULTRA.stringCode;
        quote.waiverOfPremium = quote.waiverOfPremium || false;
        quote.waiverOfPremiumAmount = quote.waiverOfPremiumAmount || 0;
        quote.carrierCode = quote.carrierCode || 'CAS';
        quote.paymentFrequency = quote.paymentFrequency || 'Monthly';
        quote.hasEcp = quote.hasEcp || false;
    }
}
